import { render, staticRenderFns } from "./UserCompanyAssignModal.vue?vue&type=template&id=a8ec40f2&lang=html&"
import script from "./UserCompanyAssignModal.vue?vue&type=script&lang=js&"
export * from "./UserCompanyAssignModal.vue?vue&type=script&lang=js&"
import style0 from "./UserCompanyAssignModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports